export const SET_WORK_PLAN_DATA = 'SET_WORK_PLAN_DATA';
export const SET_SHOW_WORK_PLAN_DUE_LIST = 'SET_SHOW_WORK_PLAN_DUE_LIST';
export const SET_SHOW_WORK_PLAN_ADD_BENF_LIST = 'SET_SHOW_WORK_PLAN_ADD_BENF_LIST';
export const SET_WORK_PLAN_BENF_DUE_LIST_PAGE_TYPE = 'SET_WORK_PLAN_BENF_DUE_LIST_PAGE_TYPE';
export const SET_WORK_PLAN_BENF_DUE_LIST_FLOW_FROM = 'SET_WORK_PLAN_BENF_DUE_LIST_FLOW_FROM';
export const SET_WORK_PLAN_SELECTED_DATE = 'SET_WORK_PLAN_SELECTED_DATE';
export const SET_WORK_PLAN_SELECTED_SERVICES_ID = 'SET_WORK_PLAN_SELECTED_SERVICES_ID';
export const SET_WORK_PLAN_REMOVAL_REASON_DATA = 'SET_WORK_PLAN_REMOVAL_REASON_DATA';
export const SET_WORK_PLAN_CALENDAR_BENEF_ID = 'SET_WORK_PLAN_CALENDAR_BENEF_ID';
export const SET_ANM_ID_SELECTED = 'SET_ANM_ID_SELECTED';
export const SET_GO_TO_BENEFICIARY_DETAIL_PAGE_FROM_WORK_PLAN = 'SET_GO_TO_BENEFICIARY_DETAIL_PAGE_FROM_WORK_PLAN';

export interface setWorkPlanDetailData {
    type: typeof SET_WORK_PLAN_DATA;
    payload: any
};

export interface setShowWorkPlanDueList {
    type: typeof SET_SHOW_WORK_PLAN_DUE_LIST;
    payload: any
};

export interface setShowWorkPlanAddBenfList {
    type: typeof SET_SHOW_WORK_PLAN_ADD_BENF_LIST;
    payload: any
};

export interface setWorkPlanListPageType {
    type: typeof SET_WORK_PLAN_BENF_DUE_LIST_PAGE_TYPE;
    payload: any
};

export interface setWorkPlanListFlowFrom {
    type: typeof SET_WORK_PLAN_BENF_DUE_LIST_FLOW_FROM;
    payload: any
};

export interface setWorkPlanSelectedCalenderdate {
    type: typeof SET_WORK_PLAN_SELECTED_DATE;
    payload: any
};

export interface setWorkPlanSelectedServicesId {
    type: typeof SET_WORK_PLAN_SELECTED_SERVICES_ID;
    payload: any
};

export interface setWorkPlanRemovalReasonData {
    type: typeof SET_WORK_PLAN_REMOVAL_REASON_DATA;
    payload: any
};

export interface setWorkPlanCalendarBenefIds {
    type: typeof SET_WORK_PLAN_CALENDAR_BENEF_ID;
    payload: any
};

export interface SetAnmIdSelected {
    type: typeof SET_ANM_ID_SELECTED;
    payload: any
};

export interface setGoToDetailPage {
    type: typeof SET_GO_TO_BENEFICIARY_DETAIL_PAGE_FROM_WORK_PLAN;
    payload: any
};

export type workPlanType = setWorkPlanDetailData | setShowWorkPlanDueList | setShowWorkPlanAddBenfList | setWorkPlanListPageType |
    setWorkPlanListFlowFrom | setWorkPlanSelectedCalenderdate | setWorkPlanSelectedServicesId | setWorkPlanRemovalReasonData |
    setWorkPlanCalendarBenefIds | SetAnmIdSelected | setGoToDetailPage;